import { act_com } from '@lc/action/cardType/Common';
import { act_summit } from '@lc/action/cardType/Summit';
import { SummitMeta } from '@lc/card/meta/SummitMeta';
import { createCardSummitVerbose } from '@lc/interface/card/summit/factory';
import { GameState } from '@lc/interface/gameState/types';

export const SummitVerbose = [
	createCardSummitVerbose(
		SummitMeta[0],
		(playerData: any, gameState: GameState) =>
			act_com.rechargeAllBatteries(playerData, gameState)
	),
	createCardSummitVerbose(
		SummitMeta[1],
		(
			playerData: any,
			gameState: GameState // create a "factory purchase" event where you whip up a payment object
		) => act_summit.buyFactoryHalfOff(playerData, gameState, 'down')
	),
	createCardSummitVerbose(
		SummitMeta[2],
		(playerData: any, gameState: GameState) =>
			act_com.gainBatteryPrecharged(playerData, gameState)
	),
	createCardSummitVerbose(
		SummitMeta[3],
		(
			playerData: any,
			gameState: GameState // create a "factory purchase" event where you whip up a payment object
		) => act_summit.buyFactoryHalfOff(playerData, gameState, 'up')
	),
	createCardSummitVerbose(
		SummitMeta[4],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayableWinterSummit(playerData, gameState)
	),
	createCardSummitVerbose(
		SummitMeta[5],
		(playerData: any, gameState: GameState) =>
			act_summit.failedNeighborContracts(playerData, gameState)
	),
	createCardSummitVerbose(
		SummitMeta[6],
		(playerData: any, gameState: GameState) =>
			act_summit.failedNeighborContracts(playerData, gameState)
	),
	createCardSummitVerbose(
		SummitMeta[7],
		(
			playerData: any,
			gameState: GameState // Eliminate Player From Award. Blacklist, sucks for now
		) => act_com.notPlayableWinterSummit(playerData, gameState)
	),
	createCardSummitVerbose(
		SummitMeta[8],
		(playerData: any, gameState: GameState) =>
			act_summit.handSizePlus2(playerData, gameState)
	),
	createCardSummitVerbose(
		SummitMeta[9],
		(playerData: any, gameState: GameState) =>
			act_summit.winterSummitHandSizeEnergy(playerData, gameState)
	),
	createCardSummitVerbose(
		SummitMeta[10],
		(playerData: any, gameState: GameState) =>
			act_summit.noFailedContracts(playerData, gameState)
	),
	createCardSummitVerbose(
		SummitMeta[11],
		(playerData: any, gameState: GameState) =>
			act_summit.highestPR(playerData, gameState)
	),
	createCardSummitVerbose(
		SummitMeta[12],
		(playerData: any, gameState: GameState) =>
			act_summit.highestPR(playerData, gameState)
	),
	createCardSummitVerbose(
		SummitMeta[13],
		(playerData: any, gameState: GameState) =>
			act_summit.energyPerEquipment(playerData, gameState)
	),
	createCardSummitVerbose(
		SummitMeta[14],
		(playerData: any, gameState: GameState) =>
			act_summit.lowestFootprint(playerData, gameState)
	),
	createCardSummitVerbose(
		SummitMeta[15],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayableWinterSummit(playerData, gameState) // add previously won summits to playerState? Blacklist for now
	),
	createCardSummitVerbose(
		SummitMeta[16],
		(playerData: any, gameState: GameState) =>
			act_summit.mostFactories(playerData, gameState)
	),
	createCardSummitVerbose(
		SummitMeta[17],
		(playerData: any, gameState: GameState) =>
			act_com.notPlayableWinterSummit(playerData, gameState) // Smallest # of batteries w/ choice. Blacklist for now
	),
	createCardSummitVerbose(
		SummitMeta[18],
		(playerData: any, gameState: GameState) =>
			act_summit.threeCompletedContracts(playerData, gameState)
	),
	createCardSummitVerbose(
		SummitMeta[19],
		(playerData: any, gameState: GameState) =>
			act_summit.mostBatteries(playerData, gameState)
	),
];
